// src/components/PaymentCalculator.js
import React, { useState, useEffect } from 'react';

// UPDATED: Accepts 'currency' prop, defaulting to '$' if not provided
const PaymentCalculator = ({ price, currency = '$' }) => {
  const [downPayment, setDownPayment] = useState(price * 0.1); // Default 10% down
  const [term, setTerm] = useState(60); // Default 60 months
  const [interestRate, setInterestRate] = useState(5.0); // Default 5%
  const [monthlyPayment, setMonthlyPayment] = useState(0);

  useEffect(() => {
    // Recalculate whenever inputs change
    const principal = price - downPayment;
    if (principal <= 0) {
        setMonthlyPayment(0);
        return;
    }
    
    // Monthly Interest Rate (Annual / 12 / 100)
    const monthlyRate = interestRate / 100 / 12;
    
    // Formula: M = P [ i(1 + i)^n ] / [ (1 + i)^n – 1 ]
    let payment = 0;
    if (monthlyRate === 0) {
        payment = principal / term;
    } else {
        payment = principal * (monthlyRate * Math.pow(1 + monthlyRate, term)) / (Math.pow(1 + monthlyRate, term) - 1);
    }

    setMonthlyPayment(isFinite(payment) ? payment : 0);
  }, [price, downPayment, term, interestRate]);

  return (
    <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #ddd' }}>
      <h3 style={{ marginBottom: '15px' }}>Payment Calculator</h3>
      
      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Vehicle Price</label>
        {/* UPDATED: Display dynamic currency */}
        <div style={{ fontSize: '1.2rem', color: '#333' }}>{currency}{price.toLocaleString()}</div>
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem' }}>Down Payment ({currency})</label>
        <input 
            type="number" 
            value={downPayment} 
            onChange={(e) => setDownPayment(Number(e.target.value))} 
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
        />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem' }}>Term (Months)</label>
            <select 
                value={term} 
                onChange={(e) => setTerm(Number(e.target.value))}
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            >
                <option value="36">36 Months</option>
                <option value="48">48 Months</option>
                <option value="60">60 Months</option>
                <option value="72">72 Months</option>
                <option value="84">84 Months</option>
            </select>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem' }}>APR (%)</label>
            <input 
                type="number" 
                value={interestRate} 
                onChange={(e) => setInterestRate(Number(e.target.value))} 
                step="0.1"
                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
      </div>

      <hr style={{ border: '0', borderTop: '1px solid #ddd', margin: '15px 0' }} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Est. Monthly Payment:</span>
          {/* UPDATED: Display dynamic currency */}
          <span style={{ fontSize: '1.5rem', color: '#007bff', fontWeight: 'bold' }}>
              {currency}{Math.round(monthlyPayment).toLocaleString()}
          </span>
      </div>
      <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '10px', fontStyle: 'italic' }}>
          *Estimated payment for informational purposes only. Actual terms may vary.
      </p>
    </div>
  );
};

export default PaymentCalculator;